import order from "../../state/order";
import BaseApi from "../baseApi";


export default class DepartmentResourceRelationApi extends BaseApi {
    async get(departmentId: string): Promise<AnydayQRCode[]> {
        const url = `/api/Anyday/qrcodes/${departmentId}`;
        return await this.fetchGet(url);
    }

    async upset(anyday: AnydayQRCode): Promise<AnydayQRCode> {
        const url = `/api/Anyday/qrcodes`;
        return await this.fetchPost(url, anyday);
    }

    async delete(id: string): Promise<void> {
        const url = `/api/Anyday/qrcodes/${id}`;
        return await this.fetchDelete(url);
    }

    async payment(order: Order, anydayQRCode: string): Promise<Blob> {
        const url = `/api/Anyday/payment/${anydayQRCode}`;
        const response = await fetch(url, {
            credentials: "same-origin",
            method: "POST",
            headers: {
                Accept: "image/png",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(order)
        });
        if (!response.ok) throw new Error("Failed to fetch QR code image");
        return await response.blob();
    }

     async order(orderid: string): Promise<OrderAnyday | null> {
        const url = `/api/Anyday/order/${orderid}`;
        return await this.fetchGet(url);
    }
   
}
